/**
 * Regular expression for matching the `void main() {` opener line in GLSL.
 * @type {RegExp}
 */
export const voidMainRegExp = /\bvoid\s+main\s*\(\s*\)\s*{/g;
